import {
  isDevelopment,
  isLocalhost,
  isProduction,
  isTesting,
} from '@/utils/environment';

import {developmentFeatureFlags} from './featureFlags.development';
import {localhostFeatureFlags} from './featureFlags.localhost';
import {productionFeatureFlags} from './featureFlags.production';
import {testingFeatureFlags} from './featureFlags.testing';
import {FeatureFlags} from './types';

export function getFeatureFlags(): FeatureFlags {
  if (isLocalhost) return localhostFeatureFlags;
  if (isDevelopment) return developmentFeatureFlags;
  if (isTesting) return testingFeatureFlags;
  if (isProduction) return productionFeatureFlags;
  return developmentFeatureFlags;
}

export const featureFlags = getFeatureFlags();
